"use client";

import { useSyncExternalStore } from "react";
import type { NextDaily, NextSteps } from "@/app/api/next-steps/route";

/** 今日の読み方を決めた合図（detail は NextDaily）。下のナビが書庫の本にしおりを差し込む演出をする */
export const DAILY_MODE_EVENT = "library:daily-mode";
export function announceDailyMode(daily: NextDaily) {
  window.dispatchEvent(new CustomEvent(DAILY_MODE_EVENT, { detail: daily }));
}

/**
 * 下のナビが読む、画面をまたいだ小さな状態。
 * - readingDone: 読了後の画面を出している（読書画面でも、読み終えたらナビを出す）
 * - nextSteps: 進化できる・道が開ける（ナビの「精霊」「地図」に点を付ける）。30秒ごとにまとめて読む
 */
type State = { readingDone: boolean; nextSteps: NextSteps | null; fetchedAt: number };

let state: State = { readingDone: false, nextSteps: null, fetchedAt: 0 };
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());
const subscribe = (l: () => void) => {
  listeners.add(l);
  return () => listeners.delete(l);
};
const serverState: State = { readingDone: false, nextSteps: null, fetchedAt: 0 };

export function useNavState(): State {
  return useSyncExternalStore(subscribe, () => state, () => serverState);
}

export function setReadingDone(done: boolean) {
  if (state.readingDone === done) return;
  state = { ...state, readingDone: done };
  emit();
}

/** 30秒より古ければ読み直す（force なら必ず）。読了・進化・道を開いたあとは force で呼ぶ */
export async function refreshNextSteps(token: string, force = false) {
  if (!force && Date.now() - state.fetchedAt < 30_000) return;
  state = { ...state, fetchedAt: Date.now() };
  try {
    const res = await fetch("/api/next-steps", { headers: { Authorization: `Bearer ${token}` } });
    if (!res.ok) return;
    state = { ...state, nextSteps: (await res.json()) as NextSteps };
    emit();
  } catch {
    // 読めなければ点を出さないだけ
  }
}
